module.exports = __webpack_public_path__ + "4bce3dfc314c85425e0db2c0488f33bb.fbx";